import { useGetWidgetSettings } from "@/api/chat-settings/get-widget-settings";
import ChatConfigurationForm from "@/components/chat-settings/chat-configuration-form/chat-configuration-form";
import ChatPreview from "@/components/chat-settings/chat-preview/chat-preview";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { cn } from "@/lib/utils";
import useGlobalPermission from "@/store/user-permissions";
import { AlertCircle } from "lucide-react";
import { useEffect, useState } from "react";

const LookAndFeel = () => {
    const { data: widgetSettings, isLoading } = useGetWidgetSettings();

    const [settingsData, setSettingsData] = useState({
        name: "Shoe Einstein",
        avatar: `${window.location.origin}/assets/images/logo/bot-icon.png`,
        welcomeMessage: "Hi, I am Shoe Einstein. An AI-based chat assistant to help you with your query. I am available 24/7 for your assistance.",
        widgetColor: "#96cef3",
        buttonSize: "m",
        buttonPosition: "bottom-right",
    });

    useEffect(() => {
        if (widgetSettings && !isLoading) {
            setSettingsData({
                name: widgetSettings?.data?.look_and_feel?.name,
                avatar: widgetSettings?.data?.look_and_feel?.avatar,
                welcomeMessage: widgetSettings?.data?.look_and_feel?.welcome_message,
                widgetColor: widgetSettings?.data?.look_and_feel?.widget_color,
                buttonSize: widgetSettings?.data?.look_and_feel?.widget_button_size,
                buttonPosition: widgetSettings?.data?.look_and_feel?.widget_button_position,
            });
        }
    }, [widgetSettings, isLoading]);

    const { permissionList } = useGlobalPermission();
    const settingsPermission = permissionList.find((item) => item.module.name === "Chat_Settings");

    return (
        <div className="relative">
            {!settingsPermission?.can_create && (
                <Alert variant="destructive" className="absolute z-10 top-1/2 right-1/2 translate-x-1/2 -translate-y-1/2 max-w-2xl">
                    <AlertCircle className="h-4 w-4" />
                    <AlertTitle>Error</AlertTitle>
                    <AlertDescription>You do not have permission to view this list!</AlertDescription>
                </Alert>
            )}
            <div className={cn("relative grid grid-cols-1 md:grid-cols-2 gap-4", !settingsPermission?.can_create && "blur-md")}>
                <>
                    <ChatConfigurationForm settingsData={settingsData} setSettingsData={setSettingsData} />
                </>
                <div className="sticky top-20 h-fit">
                    <>
                        <ChatPreview
                            name={settingsData.name}
                            avatar={settingsData.avatar}
                            welcomeMessage={settingsData.welcomeMessage}
                            widgetColor={settingsData.widgetColor}
                            isLoading={isLoading}
                        />
                    </>
                </div>
            </div>
        </div>
    );
};

export default LookAndFeel;
